// Global Types
import type {
  $Component,
} from 'common.types';

// Global Components
import * as React from 'react';

// Helpers
import {
  isDiff,
} from '@vroskus/library-helpers/dist/browser';

// Types
import type {
  $InputProps,
} from '../../../types';

type $OptionalProps = {
  className?: string;
  label?: $Component<unknown> | string;
  onChange?: (value: boolean | null) => unknown;
  value?: boolean | null;
};

type $Props = $InputProps & $OptionalProps & {
  name: string;
};

type $State = {
  value: boolean | null;
};

class InputCheckboxView extends React.Component<$Props, $State> {
  static defaultProps: $OptionalProps = {
    className: undefined,
    label: undefined,
    onChange: undefined,
    value: undefined,
  };

  constructor(props: $Props) {
    super(props);

    this.state = {
      value: props.value || null,
    };
  }

  componentDidUpdate(prevProps: $Props): void {
    const {
      setValue,
      value,
    } = this.props;

    if (isDiff(
      prevProps.value,
      value,
    )) {
      const newValue = value || null;

      this.setState({
        value: newValue,
      });

      setValue(newValue);
    }
  }

  render() {
    const {
      className,
      label,
      name,
      onChange,
      setValue,
    } = this.props;
    const {
      value,
    } = this.state;

    return (
      <div className={`InputCheckbox flex flex-row ${className || ''}`}>
        <input
          checked={value === true}
          className={'w-6 h-6 text-blue-900 bg-gray-100 rounded border-gray-300 focus:ring-blue-900 focus:ring-2'}
          id={`InputCheckbox-${name}`}
          name={name}
          onClick={() => {
            const newValue = value === null ? true : !value;

            this.setState({
              value: newValue,
            });

            setValue(newValue);

            if (onChange) {
              onChange(newValue);
            }
          }}
          type={'checkbox'}
          value={value ? 'true' : 'false'}
        />
        <label
          className={'ml-2 text-sm font-medium text-gray-900'}
          htmlFor={`InputCheckbox-${name}`}
        >
          {label}
        </label>
      </div>
    );
  }
}

export default InputCheckboxView;
